import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import EventVoting from "../views/EventVoting.vue";
import NotFound from "../views/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/:slug",
    name: "EventVoting",
    component: EventVoting,
    props: true
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
